import React from 'react';
import PropTypes from 'prop-types';
import { ButtonTransparent, Small } from 'rebass';
import styled from 'styled-components';

const TagButton = styled(ButtonTransparent)`
  border-radius: 2px;
  pointer-events: none;
`;

const Tag = ({ title }) => (
  <TagButton
    bg="greyLight"
    color="grey"
    tabIndex="-1"
    p={1}
  >
    <Small>{title}</Small>
  </TagButton>
);

Tag.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Tag;



// WEBPACK FOOTER //
// ./src/app/components/tag/index.js